import { SKTAutocompleteTextField } from "../components/SKTAutocompleteTextField";
import { SKTResults } from "../components/SKTResults";
import { SKTAction } from "../components/SKTAction";
import { SKTAddressField } from "../components/SKTAddressField";
import { SKTPayerField } from "../components/SKTPayerField";
import { SKTTextField } from "../components/SKTTextField";
import { SKTCheckbox } from "../components/SKTCheckbox";
import { SKTCarShipment } from "../components/SKTCarShipment";
import {
  passthru,
  isValidEmail,
  isValidName,
  isValidShortName,
  isValidAddress,
  isValidPhone,
  mustBeTrue,
} from "../utils/validators";
import {
  SKTPanelHeading,
  SKTPanel,
  SKTPanelBody,
} from "../components/SKTPanel";
import { SKTForm } from "../components/SKTForm";
import { API_ENDPOINTS } from "../config";
import { OrderFlow } from "./OrderFlow";
import { apiGET } from "../hooks/APIHook";
import Moment from "moment";
import { getStartDate, SKTDatePicker } from "../components/SKTDatePicker";

const AutojenkuljetuksetPhase1 = ({ data, options, moveToSecondPhase }) => {
  const requiredFields = () => {
    const routeFields = ["iSZIP", "iDZIP"];
    const dimensionFields = ["iPCarType1", "iPCarType2", "iPCarType3"];
    return [...routeFields, ...dimensionFields];
  };

  return (
    <SKTPanel>
      <SKTPanelBody>
        <SKTForm>
          <SKTAutocompleteTextField
            data={data}
            id="iSZIP"
            label="Noutopaikka"
            placeholder="00100 HELSINKI"
            options={options}
          />
          <SKTAutocompleteTextField
            data={data}
            id="iDZIP"
            label="Määräpaikka"
            placeholder="00100 HELSINKI"
            options={options}
          />
          <SKTCarShipment data={data} />
        </SKTForm>

        <SKTResults
          url={API_ENDPOINTS.priceQuery.cars}
          data={data}
          requiredFields={requiredFields}
        />
        <SKTAction
          onClick={moveToSecondPhase}
          active={true}
          actionLabel="Jatka tilausta"
        >
          Seuraavassa vaiheessa kysymme hieman tarkempia tietoja kuljetukseesi
          liittyen. Tämän jälkeen siirrytään kuljetuksen maksuun. Hyväksymme
          yleisimmät suomalaiset verkkopankit ja luottokortit.
        </SKTAction>
      </SKTPanelBody>
    </SKTPanel>
  );
};

const AutojenkuljetuksetPhase2 = ({ data, options, moveToOrderPhase }) => {
  const requiredFields = () => {
    const routeFields = [
      "iSZIP",
      "iSName",
      "iSAddr1",
      "iSPhone",
      "iSEmail",
      "iDZIP",
      "iDName",
      "iDAddr1",
      "iDPhone",
    ];
    const dimensionFields = ["iPCarType1", "iPCarType2", "iPCarType3"];
    const phase2Fields = [
      "iPMake",
      "iPModel",
      "iPRegID",
      "iPBooking",
      "accept_tc2",
      "accept_tc3",
      "accept_tc",
    ];
    return [...routeFields, ...dimensionFields, ...phase2Fields];
  };

  return (
    <SKTPanel>
      <SKTPanelBody>
        <SKTForm>
          <SKTAddressField
            corporate={true}
            label="Noutopaikan tiedot"
            data={data}
            prefix="iS"
          />
          <SKTAddressField
            corporate={true}
            label="Määräpaikan tiedot"
            data={data}
            prefix="iD"
          />
          <SKTPayerField data={data} />

          <SKTCarShipment data={data} />

          <SKTTextField
            data={data}
            id="iPMake"
            label="Ajoneuvon merkki"
            placeholder="esim. Volkswagen"
          />
          <SKTTextField
            data={data}
            id="iPModel"
            label="Ajoneuvon malli"
            placeholder="esim. Transporter"
          />
          <SKTTextField
            data={data}
            id="iPRegID"
            label="Rekisterinumero tai runkonumero"
            placeholder="ABC-123 (tai runkonumero jos ei rekisterissä)"
          />
          <SKTDatePicker
            data={data}
            id="iPBooking"
            label="Ajoneuvo on noutovalmiina"
            placeholder="Aikaisin noutopäivä muodossa pp.kk.vvvv"
          />

          <SKTTextField
            data={data}
            id="iPYourCode"
            label="Maksajan viite/lisätieto"
            placeholder="esim. tilaajan nimi, tulosyksikkö, projektinumero"
          />
          <SKTTextField
            data={data}
            id="iPInstr"
            label="Ohjeet kuljettajalle"
            placeholder="Ohjeita kuljettajalle (max 120 merkkiä)"
          />

          <SKTCheckbox
            data={data}
            label="Vakuutan että auto on ajokuntoinen ja se voidaan lastata ja purkaa ajamalla"
            id="accept_tc3"
          />
          <SKTCheckbox
            data={data}
            label="Hyväksyn että toimitan auton kuljetusliikkeen esittämään paikkaan jossa on mahdollista lastata isolla rekalla"
            id="accept_tc2"
          />
          <SKTCheckbox data={data} label="" id="accept_tc">
            Hyväksyn{" "}
            <a target="_new" href="/kayttoehdot/">
              palvelun käyttöehdot
            </a>
          </SKTCheckbox>
        </SKTForm>

        <SKTResults
          url={API_ENDPOINTS.priceQuery.cars}
          data={data}
          requiredFields={requiredFields}
        />
        <SKTAction
          onClick={moveToOrderPhase}
          active={true}
          actionLabel="Jatka tilausta"
        >
          Seuraavassa vaiheessa siirrytään kuljetuksen maksuun. Hyväksymme
          yleisimmät suomalaiset verkkopankit ja luottokortit.
        </SKTAction>
      </SKTPanelBody>
    </SKTPanel>
  );
};

const Autojenkuljetukset = (props) => {
  const options = {};

  const validators = {
    iSZIP: passthru,
    iDZIP: passthru,

    iPCarType1: passthru,
    iPCarType2: passthru,
    iPCarType3: passthru,
    iPCarType: passthru,

    iSEmail: isValidEmail,
    iDEmail: isValidEmail,
    iZEmail: isValidEmail,
    iSName: isValidName,
    iDName: isValidName,
    iSAddr1: isValidAddress,
    iDAddr1: isValidAddress,
    iSPhone: isValidPhone,
    iDPhone: isValidPhone,
    iZFirstName: isValidShortName,
    iZLastName: isValidShortName,

    iPModel: passthru,
    iPMake: passthru,
    iPRegID: passthru,
    iPBooking: passthru,

    accept_tc: mustBeTrue,
    accept_tc2: mustBeTrue,
    accept_tc3: mustBeTrue,
  };
  const defaults = {
    iPCarType1: true,
    iPCarType2: false,
    iPCarType3: false,
    iPBooking: getStartDate().format("D.M.Y"),
  };
  const createOrder = (data) => {
    const accepted =
      data.get("accept_tc") && data.get("accept_tc2") && data.get("accept_tc3");
    if (!accepted) {
      alert("Hyväksy palvelun ehdot");
      return;
    }
    const params = data.getQueryData();

    return apiGET(API_ENDPOINTS.orderCreation.cars, { params }).then(
      (result) => {
        if (result.data.secret !== undefined) return result.data.secret;
        throw new Error(result.data.stack);
      }
    );
  };

  return (
    <OrderFlow
      phase1={AutojenkuljetuksetPhase1}
      phase2={AutojenkuljetuksetPhase2}
      createOrder={createOrder}
      validators={validators}
      defaults={defaults}
      options={options}
    />
  );
};

export default Autojenkuljetukset;
